import { ReactNode } from 'react';

import { PSXHeaderWrapper, Wrapper } from './ContentWrapper.styled';

export type ContentWrapperProps = {
  children: ReactNode;
  // eslint-disable react/no-unused-prop-types
  showSearchInputBackButton?: boolean;
  isWidget?: boolean;
  pcpAlert?: boolean;
  style?: Object;
  showHeaderStyleforMap?: boolean;
};

export const ContentWrapper = ({
  children,
  isWidget,
  pcpAlert,
  style,
}: ContentWrapperProps) => (
  <Wrapper css={style} isWidget={isWidget} pcpAlert={pcpAlert}>
    {children}
  </Wrapper>
);

export const PSXHeaderContentWrapper = ({
  children,
  showSearchInputBackButton,
  showHeaderStyleforMap,
}: ContentWrapperProps) => (
  <PSXHeaderWrapper
    showHeaderStyleforMap={showHeaderStyleforMap}
    showSearchInputBackButton={showSearchInputBackButton}
  >
    {children}
  </PSXHeaderWrapper>
);
